export default __webpack_public_path__ + "static/media/amex-logo.d5cdcaee.svg";